import { Box } from '@bechtel/gds';
import { useDebounce } from '@bechtel/ht-clients-common';
import { useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { EmptySection } from '~/components';
import RequisitionDetails from './details';
import { RequisitionHeader } from './header';
import RequisitionHistoryList from './list';

export const RequisitionHistory = () => {
  const [searchText, setSearchText] = useState('');
  const debouncedSearchText = useDebounce(searchText, 500);

  return (
    <Box flexGrow={{ sm: 1 }} justifyContent={{ sm: 'center' }} flexDirection={{ sm: 'column' }}>
      <RequisitionHeader searchText={searchText} setSearchText={setSearchText} />
      <Box flexGrow={{ sm: 1 }} css={{ height: 'calc(100vh - 125px)' }}>
        <RequisitionHistoryList searchValue={debouncedSearchText} />
        <Routes>
          <Route index element={<EmptySection />} />
          <Route path=":requisitionId" element={<RequisitionDetails />} />
        </Routes>
        <Outlet></Outlet>
      </Box>
    </Box>
  );
};
